"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7531],{

/***/ 35129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ withRestoreUserSession; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ../../node_modules/supertokens-auth-react/recipe/session/index.js
var session = __webpack_require__(46709);
// EXTERNAL MODULE: ./src/store/user/User.actions.ts
var User_actions = __webpack_require__(3294);
;// CONCATENATED MODULE: ./src/hooks/useRestoreUserSession.tsx




/**
 * Hook to restore user session into the store
 * Needs to be used inside SessionAuthContext (withSessionAuth)
 */ var useRestoreUserSession = function() {
    var p = (0,session.useSessionContext)();
    var doesSessionExist = p.doesSessionExist;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        if (doesSessionExist) {
            dispatch((0,User_actions/* getMe */.jo)());
        }
    }, [
        dispatch,
        doesSessionExist
    ]);
};

;// CONCATENATED MODULE: ./src/hoc/withRestoreUserSession.tsx




/**
 * HOC that wraps a component which will also restore the user session in to the redux store.
 * @param WrappedComponent
 * @returns
 */ var withRestoreUserSession = function(WrappedComponent) {
    return function(props) {
        useRestoreUserSession();
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props));
    };
};


/***/ }),

/***/ 83240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ withSessionAuthContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var supertokens_auth_react_recipe_session__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46709);
/* harmony import */ var supertokens_auth_react_recipe_session__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(supertokens_auth_react_recipe_session__WEBPACK_IMPORTED_MODULE_2__);





var isWindow = "object" !== "undefined";
/**
 * HOC that wraps the component into a SessionAuth.
 * @param sessionAuthProps
 * @returns
 */ var withSessionAuthContext = function() {
    var sessionAuthProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(WrappedComponent) {
        var ComponentWithSession = function(props) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(supertokens_auth_react_recipe_session__WEBPACK_IMPORTED_MODULE_2__.SessionAuth, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, sessionAuthProps), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props))
            }));
        };
        return isWindow ? ComponentWithSession : function() {
            return null;
        };
    };
};


/***/ }),

/***/ 20793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getAllUsers; },
/* harmony export */   "T": function() { return /* binding */ getPendingUsers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63146);
/* harmony import */ var utils_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30430);
/* harmony import */ var _services_activateApi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4957);
/* harmony import */ var _errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92466);
/* harmony import */ var _shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5298);
/* harmony import */ var _Admin_reducer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12845);










var getAllUsers = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        showUnapproved: false
    }, page = ref.page, searchStr = ref.searchStr, _showUnapproved = ref.showUnapproved, showUnapproved = _showUnapproved === void 0 ? false : _showUnapproved, selectedLabel = ref.selectedLabel, limit = ref.limit;
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState) {
            var ref, allUsers, params, res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_3__/* .SET_IS_LOADING */ .GA)(true));
                        ref = getState(), allUsers = ref.adminReducer.allUsers;
                        if (!(!page || page && page > 0 && page <= allUsers.totalPages)) {
                            _ctx.next = 11;
                            break;
                        }
                        params = {
                            params: {
                                pendingApprobation: showUnapproved,
                                limit: limit
                            }
                        };
                        if (page) {
                            params = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, params), {
                                params: {
                                    page: page,
                                    limit: limit,
                                    pendingApprobation: showUnapproved
                                }
                            });
                        }
                        if (searchStr) {
                            params = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, params), {
                                params: {
                                    searchStr: searchStr,
                                    limit: limit,
                                    pendingApprobation: showUnapproved
                                }
                            });
                        }
                        if (selectedLabel) {
                            params.params.selectedLabel = selectedLabel;
                        }
                        _ctx.next = 9;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_1__/* .apiUser.getAllUsers */ .gh.getAllUsers(params);
                    case 9:
                        res = _ctx.sent;
                        (0,utils_helpers__WEBPACK_IMPORTED_MODULE_8__/* .customSwitch */ .bh)(res.status, {
                            200: function() {
                                dispatch((0,_Admin_reducer__WEBPACK_IMPORTED_MODULE_4__/* .SET_ALL_USERS */ .lR)(res.data));
                            },
                            default: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_2__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_9__/* .Snack */ .r(true, res.error, "error")));
                            }
                        });
                    case 11:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_3__/* .SET_IS_LOADING */ .GA)(false));
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var getPendingUsers = function() {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_3__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_1__/* .apiUser.getAllUsers */ .gh.getAllUsers({
                            params: {
                                pendingApprobation: true
                            }
                        });
                    case 3:
                        res = _ctx.sent;
                        (0,utils_helpers__WEBPACK_IMPORTED_MODULE_8__/* .customSwitch */ .bh)(res.status, {
                            200: function() {
                                dispatch((0,_Admin_reducer__WEBPACK_IMPORTED_MODULE_4__/* .SET_PENDING_USERS */ .yF)(res.data));
                            },
                            default: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_2__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_9__/* .Snack */ .r(true, res.error, "error")));
                            }
                        });
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_3__/* .SET_IS_LOADING */ .GA)(false));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};


/***/ }),

/***/ 25993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ setModalContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _documents_Documents_reducers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23836);
/* harmony import */ var _Modals_reducers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81401);




var setModalContent = function(data) {
    var refreshData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_Modals_reducers__WEBPACK_IMPORTED_MODULE_2__/* .SET_CONTENT_MODAL */ .OW)(data));
                        if (!data && refreshData) {
                            dispatch((0,_documents_Documents_reducers__WEBPACK_IMPORTED_MODULE_1__/* .SET_ONEDOCUMENT */ .O5)(null));
                            dispatch((0,_documents_Documents_reducers__WEBPACK_IMPORTED_MODULE_1__/* .SET_ONEDOCUMENT_VERSIONS */ .AE)(null));
                            dispatch((0,_documents_Documents_reducers__WEBPACK_IMPORTED_MODULE_1__/* .SET_ADDITIONAL_RESOURCES */ .aL)([]));
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};


/***/ }),

/***/ 3294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DO": function() { return /* binding */ updateMe; },
/* harmony export */   "Hi": function() { return /* binding */ approveUser; },
/* harmony export */   "LA": function() { return /* binding */ cancelInvitation; },
/* harmony export */   "Ld": function() { return /* binding */ setForgotPassword; },
/* harmony export */   "MZ": function() { return /* binding */ twoFAVerification; },
/* harmony export */   "NR": function() { return /* binding */ updateLabels; },
/* harmony export */   "Nq": function() { return /* binding */ updateUser; },
/* harmony export */   "Q": function() { return /* binding */ getPotentialEntityOwnersAutocomplete; },
/* harmony export */   "QT": function() { return /* binding */ banUser; },
/* harmony export */   "R2": function() { return /* binding */ inviteUser; },
/* harmony export */   "RK": function() { return /* binding */ importMultipleUsers; },
/* harmony export */   "SA": function() { return /* binding */ signUpUser; },
/* harmony export */   "c0": function() { return /* binding */ resetPassword; },
/* harmony export */   "c3": function() { return /* binding */ updatePreferredLanguage; },
/* harmony export */   "d4": function() { return /* binding */ removePermissions; },
/* harmony export */   "gQ": function() { return /* binding */ updatePassword; },
/* harmony export */   "jo": function() { return /* binding */ getMe; },
/* harmony export */   "ni": function() { return /* binding */ logOut; },
/* harmony export */   "o5": function() { return /* binding */ resendInvitation; },
/* harmony export */   "tD": function() { return /* binding */ setUserInfoActivated; },
/* harmony export */   "u_": function() { return /* binding */ setActivateAccount; },
/* harmony export */   "x4": function() { return /* binding */ login; },
/* harmony export */   "yu": function() { return /* binding */ addPermissions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98788);
/* harmony import */ var _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21805);
/* harmony import */ var supertokens_auth_react_recipe_session__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46709);
/* harmony import */ var supertokens_auth_react_recipe_session__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(supertokens_auth_react_recipe_session__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _sbio_interfaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37797);
/* harmony import */ var _sbio_interfaces__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_sbio_interfaces__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63146);
/* harmony import */ var utils_helpers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30430);
/* harmony import */ var _services_activateApi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4957);
/* harmony import */ var _admin_Admin_actions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20793);
/* harmony import */ var _errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92466);
/* harmony import */ var _modals_Modals_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25993);
/* harmony import */ var _shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5298);
/* harmony import */ var _User_reducers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54462);














var login = function(entries) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.login */ .gh.login({
                            email: entries.email,
                            password: entries.password,
                            captchaToken: entries.captchaToken
                        });
                    case 3:
                        res = _ctx.sent;
                        (0,utils_helpers__WEBPACK_IMPORTED_MODULE_12__/* .customSwitch */ .bh)(res.status, {
                            200: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "auth.loginSuccess", "success")));
                                js_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"].set */ .Z.set("lastRefreshSessionTokenDate", new Date().getTime().toString());
                            },
                            401: function() {
                                if (res.error.includes(_sbio_interfaces__WEBPACK_IMPORTED_MODULE_4__.Unauthorized.CANNOT_LOGIN_ACCOUNT_NOT_CONFIRMED)) {
                                    dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_RESEND_INVITATION */ .Sc)(true));
                                } else if (res.error.includes(_sbio_interfaces__WEBPACK_IMPORTED_MODULE_4__.Unauthorized.TWO_FA_REQUIRED)) {
                                    dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_2FA_VERIFICATION */ .FQ)(true));
                                } else dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                            },
                            default: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                            }
                        });
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var twoFAVerification = function(email, code) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.twoFAVerification */ .gh.twoFAVerification({
                            email: email,
                            code: code
                        });
                    case 3:
                        res = _ctx.sent;
                        _ctx.t0 = res.status;
                        _ctx.next = _ctx.t0 === 200 ? 7 : 9;
                        break;
                    case 7:
                        dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_2FA_VERIFICATION */ .FQ)(false));
                        return _ctx.abrupt("break", 11);
                    case 9:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                        return _ctx.abrupt("break", 11);
                    case 11:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var resendInvitation = function(email) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.resendInvitation */ .gh.resendInvitation({
                            email: email
                        });
                    case 3:
                        res = _ctx.sent;
                        _ctx.t0 = res.status;
                        _ctx.next = _ctx.t0 === 204 ? 7 : 9;
                        break;
                    case 7:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "pages.resetPassword.checkEmail", "success")));
                        return _ctx.abrupt("break", 11);
                    case 9:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                        return _ctx.abrupt("break", 11);
                    case 11:
                        dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_RESEND_INVITATION */ .Sc)(false));
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var approveUser = function(idUser) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.approveUser */ .gh.approveUser(idUser);
                    case 3:
                        res = _ctx.sent;
                        _ctx.t0 = res.status;
                        _ctx.next = _ctx.t0 === 204 ? 7 : 10;
                        break;
                    case 7:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "apiMessages.users.ACCOUNT_ACTIVATED", "success")));
                        dispatch((0,_admin_Admin_actions__WEBPACK_IMPORTED_MODULE_6__/* .getAllUsers */ .A)());
                        return _ctx.abrupt("break", 12);
                    case 10:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                        return _ctx.abrupt("break", 12);
                    case 12:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var cancelInvitation = function(idUser) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.cancelInvitation */ .gh.cancelInvitation({
                            idUser: idUser
                        });
                    case 3:
                        res = _ctx.sent;
                        _ctx.t0 = res.status;
                        _ctx.next = _ctx.t0 === 204 ? 7 : _ctx.t0 === 401 ? 10 : 13;
                        break;
                    case 7:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "apiMessages.users.USER_INFO_UPDATED", "success")));
                        dispatch((0,_admin_Admin_actions__WEBPACK_IMPORTED_MODULE_6__/* .getAllUsers */ .A)());
                        return _ctx.abrupt("break", 15);
                    case 10:
                        if (res.error.includes(_sbio_interfaces__WEBPACK_IMPORTED_MODULE_4__.Unauthorized.CANNOT_LOGIN_ACCOUNT_NOT_CONFIRMED)) {
                            dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_RESEND_INVITATION */ .Sc)(true));
                        }
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                        return _ctx.abrupt("break", 15);
                    case 13:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                        return _ctx.abrupt("break", 15);
                    case 15:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var getMe = function() {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.getMe */ .gh.getMe();
                    case 3:
                        res = _ctx.sent;
                        (0,utils_helpers__WEBPACK_IMPORTED_MODULE_12__/* .customSwitch */ .bh)(res.status, {
                            200: function() {
                                dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_CURRENT_USER */ .uC)(res.data));
                            },
                            default: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                                dispatch(logOut());
                            }
                        });
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var logOut = function() {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return supertokens_auth_react_recipe_session__WEBPACK_IMPORTED_MODULE_3___default().signOut();
                    case 2:
                        dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_CURRENT_USER */ .uC)(null));
                        _ctx.next = 5;
                        return next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/");
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var updatePreferredLanguage = function(data) {
    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.updateLanguage */ .gh.updateLanguage(data);
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};
var updatePassword = function(id, data) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.updatePassword */ .gh.updatePassword(id, data);
                    case 3:
                        res = _ctx.sent;
                        (0,utils_helpers__WEBPACK_IMPORTED_MODULE_12__/* .customSwitch */ .bh)(res.status, {
                            204: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "apiMessages.users.USER_INFO_UPDATED", "success")));
                            },
                            429: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "apiMessages.users.USER_INFO_UPDATED", "error")));
                            },
                            400: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "errors.auth.EMAIL_TOO_RECENTLY", "error")));
                            },
                            default: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                            }
                        });
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var setActivateAccount = function(password, token) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.activateAccount */ .gh.activateAccount(password, token);
                    case 3:
                        res = _ctx.sent;
                        (0,utils_helpers__WEBPACK_IMPORTED_MODULE_12__/* .customSwitch */ .bh)(res.status, {
                            200: function() {
                                dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_ACCOUNT_ACTIVATED */ .sh)(true));
                                dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_ACTIVATION_USERID */ .S9)(res.data._id));
                                dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_ONBOARDED_USER */ .J$)(res.data));
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "apiMessages.users.ACCOUNT_ACTIVATED", "success")));
                            },
                            409: function() {
                                dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_ONBOARDING_STATUS */ .Uq)("errors.selfHandledErrors.USER_ALREADY_ACTIVATED"));
                            },
                            default: function() {
                                dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_ONBOARDING_STATUS */ .Uq)("errors.auth.invalidOrExpiredToken"));
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                            }
                        });
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
// TODO: handle the temp token thing from before refactoring?
var setUserInfoActivated = function(id, user, token) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.putActivationData */ .gh.putActivationData(id, {
                            userData: user,
                            token: token
                        });
                    case 3:
                        res = _ctx.sent;
                        (0,utils_helpers__WEBPACK_IMPORTED_MODULE_12__/* .customSwitch */ .bh)(res.status, {
                            204: function() {
                                dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_USER_INFO_ACTIVATED */ .K6)(true));
                                dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_ONBOARDING_STATUS */ .Uq)("apiMessages.users.USER_INFO_SAVED"));
                            },
                            401: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "Unauthorized", "error")));
                            },
                            500: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "errors.general.failedToUpdateUser", "error")));
                            },
                            default: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                            }
                        });
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var addPermissions = function(id, data, closeModal) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.addPermission */ .gh.addPermission(id, data);
                    case 3:
                        res = _ctx.sent;
                        _ctx.t0 = res.status;
                        _ctx.next = _ctx.t0 === 200 ? 7 : _ctx.t0 === 204 ? 11 : 13;
                        break;
                    case 7:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "apiMessages.users.USER_INFO_UPDATED", "success")));
                        dispatch((0,_admin_Admin_actions__WEBPACK_IMPORTED_MODULE_6__/* .getAllUsers */ .A)());
                        closeModal(null);
                        return _ctx.abrupt("break", 14);
                    case 11:
                        dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_ONBOARDED_USER */ .J$)(res.data));
                        return _ctx.abrupt("break", 14);
                    case 13:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                    case 14:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var updateLabels = function(id, data, closeModal) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.updateLabels */ .gh.updateLabels(id, data);
                    case 3:
                        res = _ctx.sent;
                        _ctx.t0 = res.status;
                        _ctx.next = _ctx.t0 === 204 ? 7 : 11;
                        break;
                    case 7:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "apiMessages.users.USER_INFO_UPDATED", "success")));
                        dispatch((0,_admin_Admin_actions__WEBPACK_IMPORTED_MODULE_6__/* .getAllUsers */ .A)());
                        closeModal(null);
                        return _ctx.abrupt("break", 12);
                    case 11:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                    case 12:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var removePermissions = function(id, data, closeModal) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.removePermission */ .gh.removePermission(id, data);
                    case 3:
                        res = _ctx.sent;
                        _ctx.t0 = res.status;
                        _ctx.next = _ctx.t0 === 200 ? 7 : _ctx.t0 === 204 ? 11 : 13;
                        break;
                    case 7:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "apiMessages.users.USER_INFO_UPDATED", "success")));
                        dispatch((0,_admin_Admin_actions__WEBPACK_IMPORTED_MODULE_6__/* .getAllUsers */ .A)());
                        closeModal(null);
                        return _ctx.abrupt("break", 14);
                    case 11:
                        dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_ONBOARDED_USER */ .J$)(res.data));
                        return _ctx.abrupt("break", 14);
                    case 13:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var setForgotPassword = function(email) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.setForgotPassword */ .gh.setForgotPassword(email);
                    case 3:
                        res = _ctx.sent;
                        console.log(res);
                        _ctx.t0 = res.status;
                        _ctx.next = _ctx.t0 === 200 ? 8 : _ctx.t0 === 400 ? 11 : _ctx.t0 === 404 ? 13 : _ctx.t0 === 429 ? 16 : 18;
                        break;
                    case 8:
                        dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_FORGOT_PASSWORD_FOUND */ .T9)(true));
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "apiMessages.users.RESET_PASSWORD_EMAIL_SENT", "success")));
                        return _ctx.abrupt("break", 19);
                    case 11:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "errors.auth.EMAIL_TOO_RECENTLY", "error")));
                        return _ctx.abrupt("break", 19);
                    case 13:
                        dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_FORGOT_PASSWORD_FOUND */ .T9)(false));
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "errors.auth.emailNotFound", "error")));
                        return _ctx.abrupt("break", 19);
                    case 16:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "errors.auth.emailNotFound", "error")));
                        return _ctx.abrupt("break", 19);
                    case 18:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                    case 19:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var resetPassword = function(token, newPassword) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.resetPassword */ .gh.resetPassword(token, newPassword);
                    case 3:
                        res = _ctx.sent;
                        _ctx.t0 = res.status;
                        _ctx.next = _ctx.t0 === 204 ? 7 : 9;
                        break;
                    case 7:
                        dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_PASSWORD_RESET */ .xW)(true));
                        return _ctx.abrupt("break", 10);
                    case 9:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                    case 10:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var inviteUser = function(user, permissions, router) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.inviteUser */ .gh.inviteUser(user, permissions);
                    case 3:
                        res = _ctx.sent;
                        _ctx.t0 = res.status;
                        _ctx.next = _ctx.t0 === 200 ? 7 : _ctx.t0 === 201 ? 10 : _ctx.t0 === 204 ? 15 : _ctx.t0 === 409 ? 17 : _ctx.t0 === 500 ? 20 : 22;
                        break;
                    case 7:
                        dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_ONBOARDED_USER */ .J$)(res.data));
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                        return _ctx.abrupt("return", res);
                    case 10:
                        dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_ONBOARDED_USER */ .J$)(res.data));
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "apiMessages.users.INVITATION_SENT", "success")));
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                        router.push("/dashboard/users");
                        return _ctx.abrupt("return", res);
                    case 15:
                        dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_ONBOARDED_USER */ .J$)(res.data));
                        return _ctx.abrupt("return", res);
                    case 17:
                        dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_ONBOARDED_USER */ .J$)(res.data));
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "errors.conflict.TAKEN_EMAIL", "error")));
                        return _ctx.abrupt("break", 23);
                    case 20:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "Couldn't send invitation", "error")));
                        return _ctx.abrupt("return", res);
                    case 22:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                    case 23:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var importMultipleUsers = function(users, permissions) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var usersWithPermissions, res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        usersWithPermissions = users.map(function(user) {
                            return {
                                user: user,
                                permissions: permissions
                            };
                        });
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 4;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.importMultipleUsers */ .gh.importMultipleUsers(usersWithPermissions);
                    case 4:
                        res = _ctx.sent;
                        _ctx.t0 = res.status;
                        _ctx.next = _ctx.t0 === 201 ? 8 : _ctx.t0 === 409 ? 12 : _ctx.t0 === 500 ? 15 : 18;
                        break;
                    case 8:
                        dispatch((0,_modals_Modals_actions__WEBPACK_IMPORTED_MODULE_8__/* .setModalContent */ .o)(null));
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.data.conflicts ? "apiMessages.users.MULTIPLE_INVITATION_SENT_CONFLICT" : "apiMessages.users.MULTIPLE_INVITATION_SENT", "success")));
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                        return _ctx.abrupt("return", res);
                    case 12:
                        dispatch((0,_User_reducers__WEBPACK_IMPORTED_MODULE_10__/* .SET_ONBOARDED_USER */ .J$)(res.data));
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "errors.conflict.TAKEN_EMAIL", "error")));
                        return _ctx.abrupt("break", 19);
                    case 15:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "Couldn't send invitation", "error")));
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                        return _ctx.abrupt("return", res);
                    case 18:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                    case 19:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                        dispatch((0,_modals_Modals_actions__WEBPACK_IMPORTED_MODULE_8__/* .setModalContent */ .o)(null));
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var updateUser = function(id, data, closeModal) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState) {
            var ref, userData, res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = getState(), userData = ref.userReducer.userData;
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 4;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.updateUser */ .gh.updateUser(id, data);
                    case 4:
                        res = _ctx.sent;
                        (0,utils_helpers__WEBPACK_IMPORTED_MODULE_12__/* .customSwitch */ .bh)(res.status, {
                            204: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "apiMessages.users.USER_INFO_UPDATED", "success")));
                                dispatch((0,_admin_Admin_actions__WEBPACK_IMPORTED_MODULE_6__/* .getAllUsers */ .A)());
                                if (userData._id === id) {
                                    dispatch(getMe());
                                }
                                if (closeModal) closeModal(null);
                            },
                            default: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                            }
                        });
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var signUpUser = function(data) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.signUpUser */ .gh.signUpUser(data);
                    case 3:
                        res = _ctx.sent;
                        (0,utils_helpers__WEBPACK_IMPORTED_MODULE_12__/* .customSwitch */ .bh)(res.status, {
                            200: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "apiMessages.users.SIGN_UP_REQUEST_SENT", "success")));
                                dispatch((0,_modals_Modals_actions__WEBPACK_IMPORTED_MODULE_8__/* .setModalContent */ .o)(null));
                            },
                            409: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "apiMessages.users.ADDRESS_EMAIL_ALREADY_USED", "error")));
                            },
                            default: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                            }
                        });
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var updateMe = function(data) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.updateMe */ .gh.updateMe(data);
                    case 3:
                        res = _ctx.sent;
                        (0,utils_helpers__WEBPACK_IMPORTED_MODULE_12__/* .customSwitch */ .bh)(res.status, {
                            204: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "apiMessages.users.USER_INFO_UPDATED", "success")));
                                dispatch(getMe());
                            },
                            default: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                            }
                        });
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var banUser = function(id) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(true));
                        _ctx.next = 3;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.banUser */ .gh.banUser(id);
                    case 3:
                        res = _ctx.sent;
                        _ctx.t0 = res.status;
                        _ctx.next = _ctx.t0 === 204 ? 7 : 10;
                        break;
                    case 7:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, "apiMessages.users.USER_INFO_UPDATED", "success")));
                        dispatch((0,_admin_Admin_actions__WEBPACK_IMPORTED_MODULE_6__/* .getAllUsers */ .A)());
                        return _ctx.abrupt("break", 11);
                    case 10:
                        dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                    case 11:
                        dispatch((0,_shared_Shared_reducers__WEBPACK_IMPORTED_MODULE_9__/* .SET_IS_LOADING */ .GA)(false));
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var getPotentialEntityOwnersAutocomplete = function(searchTerm, resource) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res;
            return _builds_sparkmate_sbio_secbio_sbio_core_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _services_activateApi__WEBPACK_IMPORTED_MODULE_5__/* .apiUser.getPotentialEntityOwnersAutocomplete */ .gh.getPotentialEntityOwnersAutocomplete(searchTerm, resource);
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", (0,utils_helpers__WEBPACK_IMPORTED_MODULE_12__/* .customSwitch */ .bh)(res.status, {
                            200: function() {
                                return (res === null || res === void 0 ? void 0 : res.data) || [];
                            },
                            default: function() {
                                dispatch((0,_errors_Errors_reducer__WEBPACK_IMPORTED_MODULE_7__/* .SET_SNACKBAR */ .zt)(new components_Snackbar_Snackbar_entity__WEBPACK_IMPORTED_MODULE_13__/* .Snack */ .r(true, res.error, "error")));
                            }
                        }));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};


/***/ }),

/***/ 30430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ju": function() { return /* binding */ isEmailValid; },
/* harmony export */   "PQ": function() { return /* binding */ entityFromAlgolia; },
/* harmony export */   "bh": function() { return /* binding */ customSwitch; }
/* harmony export */ });
/* unused harmony exports emailTest, removeTextLayerPdfViewer */
var emailTest = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
function removeTextLayerPdfViewer() {
    // This function will remove this dirty html text overlay of PDF document - but we loose the 'search by text in pdf' function.
    var textLayers = document.querySelectorAll(".react-pdf__Page__textContent");
    textLayers.forEach(function(layer) {
        // @ts-expect-error: I know that style exists on textLayer
        var style = layer.style;
        // FROM: https://github.com/wojtekmaj/react-pdf/issues/332
        style.display = "none";
    });
}
var customSwitch = function() {
    var oneCase = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "default", cases = arguments.length > 1 ? arguments[1] : void 0;
    var result = cases[oneCase.toString()];
    return (result || cases["default"])();
};
var isEmailValid = function(email) {
    var emailSchema = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailSchema.test(String(email).toLowerCase());
};
var entityFromAlgolia = function(indexName) {
    if (indexName) {
        if (indexName.includes("course")) return "elearning";
        if (indexName.includes("document")) return "documents";
    } else {
        return null;
    }
};


/***/ })

}]);